// ── 미팅지도 계약 상품 도우미 (순수 함수) ────────────────────────────────────────
//   2026-10-22 useMeetingMapHandlers.js(290줄)에서 옮김 — 미팅지도 관리 회사별·통합 분리 1단계(동작 변화 0).
//   '외부 분류 → 기본 상품' 바꾸기는 같은 코드가 두 곳에 있어 하나로 모았다(같은 계산).

/**
 * 결과 폼의 선택 상품 중 외부 분류 이름을 그 분류의 기본 상품으로 바꾸고, 유효기간 기본값을 채운다.
 * setResultForm 에 넘길 갱신 함수를 돌려준다(바뀐 게 없으면 prev 그대로).
 */
export function resolveExternalProducts(extCats, allProducts) {
  return (prev) => {
    const current = prev.selectedProducts || [];
    const resolved = current.map((name) => {
      const cat = extCats.find((c) => c.name === name);
      return cat?.default_product_name || name;
    });
    const newValidities = { ...prev.productValidities };
    let validityChanged = false;
    resolved.forEach((name) => {
      if (!newValidities[name]) {
        const product = allProducts.find((t) => t.name === name);
        if (product?.default_validity_months != null) {
          newValidities[name] = String(product.default_validity_months);
          validityChanged = true;
        }
      }
    });
    const nameChanged = resolved.some((n, i) => n !== current[i]);
    if (!nameChanged && !validityChanged) return prev;
    return { ...prev, selectedProducts: resolved, productValidities: newValidities };
  };
}

// "동반할인권(8개월)" → { name: '동반할인권', validity: '8' }
export function extractValidity(rawName) {
  const m = String(rawName || '').match(/^(.*?)\((\d+)개월\)$/);
  return m ? { name: m[1], validity: m[2] } : { name: rawName, validity: '' };
}

// ticket_type 문자열 → selectedProducts / productCounts 역파싱
//   저장 형식: "상품명×장수, 상품명×장수" 또는 단순 "상품명"
export function parseContractTicketString(ticketType, ticketCount) {
  const str = String(ticketType || '').trim();
  if (!str) return { selectedProducts: [], productCounts: {} };
  if (str.includes('×')) {
    const selectedProducts = [];
    const productCounts = {};
    str.split(', ').forEach((part) => {
      const idx = part.indexOf('×');
      const name = part.slice(0, idx).trim();
      const cnt  = part.slice(idx + 1).trim();
      if (name) { selectedProducts.push(name); if (cnt) productCounts[name] = cnt; }
    });
    return { selectedProducts, productCounts };
  }
  // 단일 상품
  const productCounts = ticketCount != null && ticketCount !== ''
    ? { [str]: String(ticketCount) } : {};
  return { selectedProducts: [str], productCounts };
}
